<template>
    <div>
        <div class="leaderBox" v-if="showOrhide1">
            <div class="newtext">新手指引</div>
            <img src="../../../assets/images/maskClose.png" class="closeIt" @click="closeIt1">
            <img src="../../../assets/images/xqgl1.png" class="steps step4" v-if="status1==1">
            <img src="../../../assets/images/xqgl2.png" class="steps step5" v-if="status1==2">
            <img src="../../../assets/images/xqgl3.png" class="steps step6" v-if="status1==3">
            <img src="../../../assets/images/xqgl4.png" class="steps step7" v-if="status1==4">
            <div class="stepbtn" @click="nextStep1(status1)">
                {{status1==1?"下一步":status1==2?"下一步":status1==3?"下一步":status1==4?"我知道了":"我知道了"}}
            </div>
            <div class="bottomTip">
                <el-checkbox v-model="checked1">下次不再提示</el-checkbox>
            </div>
        </div>
<!--        <breadcrumb :routerList="[{to:'/xuqiu/resourceList',title:'协同管理'},{title:'协同问题列表'}]"/>-->
      <Breadtabsheader/>
        <div style="margin:20px">
            <div class="h-piece">
                <div class="h-formBox">
                    <el-form :inline="true" :model="q" class="demo-form-inline h-formBorder">
                        <div class="h-thirdColumn w-newColumn">
                            <el-form-item label="客户名称">
                                <el-input v-model="q.euNameLike" placeholder="请输入客户名称"></el-input>
                            </el-form-item>
                            <el-form-item label="区域">
                                <brselect category="YLRegion" :v="q.areaCode" v-model="q.areaCode" :clearable="true"
                                          style="width:100%"/>
                            </el-form-item>
                            <el-form-item label="承接部门">
                                <el-select v-model="q.jobGroup" :v="q.jobGroup"
                                           placeholder="请选择" :clearable="true"
                                           @change="okJobPoint">
                                    <el-option v-for="(item) in JobGroup"
                                               :key="item.id"
                                               :label="item.jobGroup"
                                               :value="item.jobGroup"
                                    >
                                    </el-option>
                                </el-select>
                            </el-form-item>
                            <el-form-item label="提报人">
                                <el-input v-model="q.cuname" placeholder="请输入名称"></el-input>
                            </el-form-item>
                        </div>
                        <el-collapse-transition>
                            <div v-show="isScreen">
                                <div class="h-thirdColumn w-newColumn">
                                    <el-form-item label="提报日期" class="timeselect" style="width: 50%;">
                                        <el-date-picker
                                                placeholder="请选择"
                                                v-model="q.startCdate"
                                                clearable
                                                type="date"
                                                value-format="yyyy-MM-dd" >
                                        </el-date-picker>
                                        <span class="w-time-to">至</span>
                                        <el-date-picker
                                                placeholder="请选择"
                                                v-model="q.endCdate"
                                                clearable
                                                type="date"
                                                value-format="yyyy-MM-dd" >
                                        </el-date-picker>
                                    </el-form-item>
                                    <el-form-item label="抢入链群">
                                        <el-select filterable v-model="q.lianqunCode" clearable placeholder="请选择"
                                        >
                                            <el-option
                                                    v-for="(item,index) in lianqunList"
                                                    :key="item.chainGroupCode"
                                                    :label="item.chainGroupName"
                                                    :value="item.chainGroupCode">
                                            </el-option>
                                        </el-select>
                                    </el-form-item>
                                  <el-form-item label="部门">
                                    <el-select filterable v-model="q.cdept" clearable placeholder="请选择"
                                    >
                                      <el-option
                                          v-for="(item,index) in deptList"
                                          :key="item.dept"
                                          :label="item.dept"
                                          :value="item.dept">
                                      </el-option>
                                    </el-select>
                                  </el-form-item>
                                </div>
                            </div>
                        </el-collapse-transition>
                    </el-form>
                    <div class="l-screenBox">
                        <div class="l-screen" @click="collapseChange">
                            <img :src="isScreen?closeScreen:drawScreen" alt="">
                            <div class="l-screenText">{{isScreen?"收起":"展开"}}</div>
                        </div>
                        <div class="l-retrieval">
                            <el-button class="h-btn h-formBtn" @click="handleFilter">检索</el-button>
                            <el-button class="h-btn h-formBtn h-bgwhite" @click="resetData">重置
                            </el-button>
                            <el-button class="h-btn h-formBtn h-bggreen" icon="el-icon-plus"
                                       @click="createdemand">新增问题
                                <!-- v-auth="'xuqiu_xinzengzyxuqiu'"-->
                            </el-button>
                        </div>
                    </div>
                </div>
            </div>
            <div class="h-row ljjtablexuqius">
                <div class="h-rowIn" style="width: 100%;">
                    <div style="height: 15.3rem;overflow: hidden;position: relative;">
                        <div class="h-rowBox" style="border-bottom: none;box-shadow: none;">
                            <div class="h-rowTitle h-pdl0">
                                <div class="h-el-tab">
                                    <ul>
                                        <li :class="{'h-active':index==indx}" v-for="(item,index) in list" :key="index"
                                            @click="tabIndex(index)"><a>{{item}}</a></li>
                                    </ul>
                                </div>
                            </div>
                            <el-table
                                    class="ljjtablesdata"
                                    ref="multipleTable"
                                    :span-method="objectSpanMethod"
                                    :data="tableData"
                                    :border="true"
                                    stripe
                                    style="width: 100%">
                                <el-table-column
                                        label="状态"
                                >
                                    <template slot-scope="scope">
                                        <div  v-if="scope.row.isLoop == 1" style="color: #2eaf68;border-radius: 0.2rem;padding: 0.05rem;">
                                            已闭环
                                        </div>
                                        <div  v-if="scope.row.isLoop == 0 && scope.row.inNumber== 0 && scope.row.isOverdue ==0 && scope.row.isTrip==0" style="color: #258efe;border-radius: 0.2rem;padding: 0.05rem;">
                                            未回复
                                        </div>
                                        <div  v-if="scope.row.isLoop ==0 && scope.row.inNumber==1" style="color: #BF3EFF;border-radius: 0.2rem;padding: 0.05rem;">
                                            未闭环
                                        </div>

                                        <div v-if="scope.row.isLoop ==0 && scope.row.inNumber==0 && scope.row.isOverdue ==1 && scope.row.isTrip==0" style="color: #f2bd2e;border-radius: 0.2rem;padding: 0.05rem;">
                                            逾期
                                        </div>
                                    </template>
                                </el-table-column>
                                <el-table-column
                                        prop="cuname"
                                        label="提报人"
                                >
                                </el-table-column>
                                <el-table-column
                                        prop="areaCode"
                                        label="区域"
                                >
                                    <template slot-scope="scope">
                                        {{scope.row.areaCode | dictname('YLRegion')}}
                                    </template>
                                </el-table-column>
<!--                                <el-table-column
                                        prop="euType"
                                        label="客户类型"
                                >
                                    <template slot-scope="scope">
                                        <span v-if="scope.row.euType == 1">潜在经销商</span>
                                        <span v-if="scope.row.euType == 2">潜在客户</span>
                                    </template>
                                </el-table-column>-->
                                <el-table-column
                                        prop="euName"
                                        label="客户名称"
                                        :show-overflow-tooltip="true"
                                >
                                    <template slot-scope="scope">
                                        <div style="text-align: left;">{{scope.row.euName}}</div>
                                    </template>
                                </el-table-column>
                                <el-table-column
                                        prop="jobGroup"
                                        label="承接部门"
                                        :show-overflow-tooltip="true"
                                >
                                    <template slot-scope="scope">
                                        <div style="text-align: left;">{{scope.row.jobGroup}}</div>
                                    </template>
                                </el-table-column>
                                <el-table-column
                                        prop="jobUsername"
                                        label="要求答复人"
                                        :show-overflow-tooltip="true"
                                >
                                    <template slot-scope="scope">
                                        <div style="text-align: left;">{{scope.row.jobUsername}}</div>
                                    </template>
                                </el-table-column>
<!--                                <el-table-column-->
<!--                                        prop="lianqunName"-->
<!--                                        label="抢入链群"-->
<!--                                        :show-overflow-tooltip="true"-->
<!--                                >-->
<!--                                    <template slot-scope="scope">-->
<!--                                        <div style="text-align: left;">{{scope.row.lianqunName}}</div>-->
<!--                                    </template>-->
<!--                                </el-table-column>-->
                                <el-table-column
                                        prop="content"
                                        :show-overflow-tooltip="true"
                                        label="协同问题">
                                    <template slot-scope="scope">
                                        <div style="text-align: left;">{{scope.row.content}}</div>
                                    </template>
                                </el-table-column>

                              <el-table-column
                                  prop="content"
                                  :show-overflow-tooltip="true"
                                  label="提报时间">
                                <template slot-scope="scope">
                                  <div style="text-align: left;">{{scope.row.raiseProblemTime}}</div>
                                </template>
                              </el-table-column>

                              <el-table-column
                                  prop="content"
                                  :show-overflow-tooltip="true"
                                  label="闭环时长">
                                <template slot-scope="scope">
                                  <div style="text-align: left;" v-if="scope.row.raiseAnswerTime === null">
                                    未闭环
                                  </div>
                                  <div style="text-align: left;" v-if="scope.row.raiseAnswerTime != null">
                                    {{scope.row.raiseAnswerTime}}
                                  </div>
                                </template>
                              </el-table-column>
                              <el-table-column
                                  prop="problemType"
                                  label="问题分类"
                              >
                                <template slot-scope="scope">
                                  {{scope.row.problemType | dictname('xtwt_type')}}
                                </template>
                              </el-table-column>

                                <el-table-column
                                        prop="endDate"
                                        label="答复截止时间"
                                        :show-overflow-tooltip="true"
                                >
                                    <template slot-scope="scope">
                                        <div style="text-align: left;">{{scope.row.endDate}}</div>
                                    </template>
                                </el-table-column>
                                <el-table-column
                                        fixed="right"
                                        label="操作"
                                >
                                    <template slot-scope="scope">
                                        <div style="text-align: left;">
                                            <el-button
                                                    size="small" class="h-tableLink h-btn"
                                                    @click="xuqiuDetail(scope.row)">详情
                                            </el-button>
                                        </div>
                                    </template>
                                </el-table-column>
                            </el-table>
<!--                            <div class="fenyes" style="margin-top: 0.3rem">
                                <el-button class="h-btn h-formBtn h-bgblueQ" icon="h-el-icon h-el-icon-import"
                                           @click="exportExcel">批量导出
                                </el-button>
                                <pagination :page="q" @query="query" style="padding-top: 0.1rem"/>
                            </div>-->
<!--                            <div v-if="tableData.length<5"-->
<!--                                 style="display:flex;justify-content:center;padding-top: 30px;align-items: center;">-->
<!--                                <img src="../../../assets/images/mylittle.png" alt="" style="width: 75%;">-->
<!--                            </div>-->
<!--                            <div class="h-rowBoxB h-rowBoxBtnOut"-->
<!--                                 style="margin: 0;padding: 0.11rem 0.26rem;display: flex;align-items: center;height: 67px;position: absolute;bottom: 0;left: 0;width: 100%;border: 1px solid #d7e0f1;">-->
<!--                                &lt;!&ndash; <el-checkbox v-model="checkAll" @change="handleCheckAllChange">全选</el-checkbox>&ndash;&gt;-->
<!--                                <el-button class="h-btn h-formBtn h-bgblueQ" icon="h-el-icon h-el-icon-import"-->
<!--                                           @click="exportExcel">批量导出-->
<!--                                    &lt;!&ndash;v-auth="'xuqiu_zypiliangdaochu'"&ndash;&gt;-->
<!--                                </el-button>-->
<!--                            </div>-->
                        </div>
                        <div class="h-tableB h-mrt30">
                            <div class="h-tableBL">
                                <el-button class="h-btn h-formBtn h-bgblueQ" icon="h-el-icon h-el-icon-import"
                                           @click="exportExcel">批量导出
                                </el-button>
                            </div>
                            <div class="h-pagination2">
                                <pagination :page="q" @query="query" style="padding-top: 0.1rem"/>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import ss from '../../../api/SystemService'
    import updownfile from '../../../utils/updownfile'
    import uploaddownexcel from '../../../components/uploaddown/uploaddownexcel'

    export default {
        components: {
            uploaddownexcel,
        },
        data() {
            return {
                // 展开折叠筛选
                isScreen:false,
                closeScreen:require("@/assets/images/pimg/closeallic.png"),
                drawScreen:require("@/assets/images/pimg/dobleArr.png"),
                lianData:[],
                //链群
                JobGroup: [],
               deptList: [],
                JobPoint:[],
                showOrhide1: false,
                status1: 1,
                checked1: true,
                toshow1: "Lmanagement3",
                imgflag2: false,
                //caifile:false,
                //xuqiu:false,
                //ziyuan:false,
                //当前登陆人的权限列表
                rolelist: [],
                lianqunList : [],
                //导入Excel
                uploaddownexcelflag: false,
                caiuploaddownexcelflag: false,
                ziuploaddownexcelflag: false,
                timeValue: null,
                shoor: false,
                //全选
                /* checkedCities: [],
                 cities: this.cityOptions,
                 cityOptions: [],
                 checkAll: false,*/
                multipleSelection: [],
                lianqunShow:true,
                detailShow: false,
                xuqiudex: 0,
                dialogFormVisible1: false,
                dialogFormVisible2: false,
                formLabelAlign2: {},
                val: [],
                n: {},
                //切换
                indx: 0,
                // list: ['全部', '已闭环', '未闭环','未回复','逾期'],
                list: ['未回复', '未闭环', '已闭环','逾期','全部'],
                q: {
                    startCdate: '',
                    endCdate: '',
                    euNameLike: null,
                    jobGroup:null,
                    jobPoint:null,
                    areaCode:null,
                    cuname:null,
                    isLoop:null,
                    isTrip:null,
                    isOverdue:null,
                    inNumber:null,
                    lianqunCode: '',
                    pageSize: 10,
                    pageNo: 1,
                    total: 0,
                },
                l:{
                    jobGroupPoint:null,
                    jobGroup:null,
                    pageSize: 6,
                    pageNo: 1,
                    total: 0,
                },
                tablelist: [],
                tableName: {},
                tableData: [],
                LevelName: [],
                qdetail: {
                    id: null,
                    demandType: null,
                    customer: {
                        areaCode: null,
                    }
                },
                //表单
                f: {
                    demandType: null,
                    rdId: null,
                    userCode: null,
                    resDescribe: null,
                    content: null,
                    cid: null,
                    remark: null,
                    cucode: null,
                    cuname: null,
                    cdate: null,
                    lucode: null,
                    ldate: null,
                    delflag: null,
                    endDate: null,
                    euCode: null,
                    euName: null,
                    detail: [
                        {
                            depName: null,
                        }
                    ],
                    customer: [],
                },
                //弹出框
                dialogFormVisible: false,
                chartPer: {
                    all: 0,
                    wbh:0,
                    whf:0,
                    yq:0,
                    ybh:0,
                    tz:0
                },
                options: {},
                ifchart: true,
                CGList: [],
                DDList: [],
                ZYList: [],
            }
        },
        beforeRouteLeave(to, from, next) {
            from.meta.keepAlive = false;
            next();
        },
        activated(){
            this.query();
        },
        methods: {
            // 展开折叠
            collapseChange(){
                this.isScreen = !this.isScreen;
            },
            getSpanArr() {
                this.spanArr = [];
                this.tableData.forEach((item, index) => {
                    if (index === 0) {
                        this.spanArr.push(1);
                        this.position = 0;
                    } else {
                        if (this.tableData[index].rdId === this.tableData[index - 1].rdId) {
                            this.spanArr[this.position] += 1;
                            this.spanArr.push(0);
                        } else {
                            this.spanArr.push(1);
                            this.position = index;
                        }
                    }
                })
            },
            objectSpanMethod({row, column, rowIndex, columnIndex}) {
                /*                if (column.label == '提报人' || column.label == '区域'||column.label == '客户类型'||column.label == '客户全称'||column.label == '联系人'
                                    ||column.label == '联系方式'||column.label == '截止时间'||column.label == '描述'||column.label == '创建日期'||column.label == '回复'){*/
                // if (column.label != '承接部门'&&column.label != '答复人'&&column.label != '状态'){
                if (column.label == '区域'||column.label == '客户类型'||column.label == '客户名称'){
                    const _row = this.spanArr[rowIndex];
                    const _col = _row > 0 ? 1 : 0;
                    return {
                        rowspan: _row,
                        colspan: _col
                    }
                }
            },
            //右下角链群表格
            lianDataPage(v){
                if(v){
                    this.l.jobGroup = v.jobGroup;
                    this.l.pageSize = 6;
                    this.l.pageNo = 1;
                    this.l.total = 0;
                }
                ss.UserDemand.lianDataPage(this.l).then(rd => {
                    this.l.total = rd.total;
                    this.lianData = rd.records;
                });
            },
            //节点筛选可用
            okJobPoint(){
                if(this.q.jobGroup!=null){
                    // ss.UserDemand.selectJobPoint(this.q.jobGroup).then(rd => {
                    ss.xietongguanli.selectDeptPoint(this.q.jobGroup).then(rd => {
                        this.JobPoint = rd;
                    });
                }else{
                    this.JobPoint=null;
                    this.q.jobPoint = null;
                }
            },
            //部门列表
            selectJobGroup() {
                ss.xietongguanli.selectDeptPoint(this.q.jobGroup).then(rd => {
                    this.JobGroup = rd;
                });
            },
            showzhezhao() {
                ss.salesList.toshow(this.toshow1).then(rd => {
                    if (rd == false) {
                        this.showOrhide1 = false;
                    } else {
                        this.showOrhide1 = true;
                    }
                })
            },
            timeSelect() {
                if (this.timeValue == null || this.timeValue == '') {
                    this.q.startCdate = null;
                    this.q.endCdate = null;
                } else {
                    this.q.startCdate = this.timeValue[0];
                    console.log("1111111",this.q.startCdate)
                    this.q.endCdate = this.timeValue[1];
                    console.log("1111111",this.q.endCdate)
                }
            },
            daoru() {
                this.dialogFormVisible2 = true;
            },
            //重置检索项
            resetData() {
                this.q.jobGroup = null;
                this.q.jobPoint = null;
                this.q.euNameLike = null;
                this.q.areaCode = null;
                this.timeValue = null;
                this.q.startCdate = null;
                this.q.endCdate = null;
                this.q.lianqunCode = null;
            },
            getDept(q){
              ss.MuBiao.getDeptList(q).then(rd => {
                this.deptList = rd;
              })
            },
            //检索
            handleFilter(query) {
                this.query();
            },
            //全部/已转化/为转化标签
            tabIndex(i) {
                this.indx = i;
                if (this.indx == 4) {
                    this.q.isLoop =null ;
                    this.q.inNumber = null;
                    this.q.isOverdue =null ;
                    this.q.isTrip = null;
                    this.query();
                    this.options.series.data = [
                        {
                            value: this.chartPer.wbh ? this.chartPer.wbh : 0,
                            name: '未闭环'
                        },
                        {
                            value: this.chartPer.ybh ? this.chartPer.ybh : 0,
                            name: '已闭环',

                        },
                        {
                            value: this.chartPer.whf ? this.chartPer.whf : 0,
                            name: '未回复',

                        },
                        {
                            value: this.chartPer.yq ? this.chartPer.yq : 0,
                            name: '逾期',

                        },
                        {
                            value: this.chartPer.tz ? this.chartPer.tz : 0,
                            name: '跳闸',

                        }
                    ];
                } else if (this.indx == 2) {
                    this.q.inNumber = null;
                    this.q.isOverdue =null ;
                    this.q.isTrip = null;
                    this.q.isLoop = 1;
                    this.query();
                    this.options.series.data = [
                        {
                            value: this.chartPer.wbh ? this.chartPer.wbh : 0,
                            name: '未闭环'
                        },
                        {
                            value: this.chartPer.ybh ? this.chartPer.ybh : 0,
                            name: '已闭环',
                            selected:true,
                        },
                        {
                            value: this.chartPer.whf ? this.chartPer.whf : 0,
                            name: '未回复',
                        },
                        {
                            value: this.chartPer.yq ? this.chartPer.yq : 0,
                            name: '逾期',
                        },
                        {
                            value: this.chartPer.tz ? this.chartPer.tz : 0,
                            name: '跳闸',
                        }
                    ];
                } else if (this.indx == 1) {
                    this.q.isOverdue =null ;
                    this.q.isTrip = null;
                    this.q.isLoop =0;
                    this.q.inNumber =1 ;
                    this.query();
                    this.options.series.data = [
                        {
                            value: this.chartPer.wbh ? this.chartPer.wbh : 0,
                            name: '未闭环',
                            selected:true,
                        },
                        {
                            value: this.chartPer.ybh ? this.chartPer.ybh : 0,
                            name: '已闭环',
                        },
                        {
                            value: this.chartPer.whf ? this.chartPer.whf : 0,
                            name: '未回复',
                        },
                        {
                            value: this.chartPer.yq ? this.chartPer.yq : 0,
                            name: '逾期',
                        },
                        {
                            value: this.chartPer.tz ? this.chartPer.tz : 0,
                            name: '跳闸',
                        }
                    ];
                }else if (this.indx == 0) {
                    this.q.isLoop =0 ;
                    this.q.inNumber = 0;
                    this.q.isOverdue =0 ;
                    this.q.isTrip = 0;
                    this.query();
                    this.options.series.data = [
                        {
                            value: this.chartPer.wbh ? this.chartPer.wbh : 0,
                            name: '未闭环'
                        },
                        {
                            value: this.chartPer.ybh ? this.chartPer.ybh : 0,
                            name: '已闭环',
                        },
                        {
                            value: this.chartPer.whf ? this.chartPer.whf : 0,
                            name: '未回复',
                            selected:true,
                        },
                        {
                            value: this.chartPer.yq ? this.chartPer.yq : 0,
                            name: '逾期',
                        },
                        {
                            value: this.chartPer.tz ? this.chartPer.tz : 0,
                            name: '跳闸',

                        }
                    ];
                }else if (this.indx == 3) {
                    this.q.isLoop =0 ;
                    this.q.inNumber= 0;
                    this.q.isOverdue =1 ;
                    this.q.isTrip= 0;
                    this.query();
                    this.options.series.data = [
                        {
                            value: this.chartPer.wbh ? this.chartPer.wbh : 0,
                            name: '未闭环'
                        },
                        {
                            value: this.chartPer.ybh ? this.chartPer.ybh : 0,
                            name: '已闭环',

                        },
                        {
                            value: this.chartPer.whf ? this.chartPer.whf : 0,
                            name: '未回复',

                        },
                        {
                            value: this.chartPer.yq ? this.chartPer.yq : 0,
                            name: '逾期',
                            selected:true,
                        },
                        {
                            value: this.chartPer.tz ? this.chartPer.tz : 0,
                            name: '跳闸',

                        }
                    ];
                }else if (this.indx == 5) {
                    this.q.isLoop =0 ;
                    this.q.inNumber= 0;
                    this.q.isOverdue =1 ;
                    this.q.isTrip= 1;
                    this.query();
                    this.options.series.data = [
                        {
                            value: this.chartPer.wbh ? this.chartPer.wbh : 0,
                            name: '未闭环'
                        },
                        {
                            value: this.chartPer.ybh ? this.chartPer.ybh : 0,
                            name: '已闭环',

                        },
                        {
                            value: this.chartPer.whf ? this.chartPer.whf : 0,
                            name: '未回复',

                        },
                        {
                            value: this.chartPer.yq ? this.chartPer.yq : 0,
                            name: '逾期',

                        },
                        {
                            value: this.chartPer.tz ? this.chartPer.tz : 0,
                            name: '跳闸',
                            selected:true,
                        }
                    ];
                }
                this.getPieChartnow();
                this.ifchart = true;
                this.detailShow = false;
                this.lianqunShow = true;
            },
            //表格
            query() {
                ss.xietongguanli.showXTGLPage(this.q).then(rd => {
                    this.q.total = rd.total;
                    this.tableData = rd.records;
                    this.getSpanArr();
                });
            },
            //获取抢入链群信息
            getAllLianqun(){
                ss.createMonthGoal.getAllLianqun().then(rd => {
                    this.lianqunList = rd;
                })
            },
            //表格
            query1() {
                this.q.isLoop =0 ;
                this.q.inNumber = 0;
                this.q.isOverdue =0 ;
                this.q.isTrip = 0;
                ss.xietongguanli.showXTGLPage(this.q).then(rd => {
                    this.q.total = rd.total;
                    this.tableData = rd.records;
                    this.getSpanArr();
                });
            },
            getPieChartnow() {
                let h_gaugePie = this.$echarts.init(document.getElementById('h_gaugePie'));
                let placeHolderStyle = {
                    normal: {
                        color: 'rgba(0,0,0,0)',
                        label: {show: false},
                        labelLine: {show: false}
                    },
                    emphasis: {
                        color: 'rgba(0,0,0,0)'
                    }
                };

                h_gaugePie.setOption(this.options);
            },
            getPieChart() {
                let h_gaugePie = this.$echarts.init(document.getElementById('h_gaugePie'));
                let placeHolderStyle = {
                    normal: {
                        color: 'rgba(0,0,0,0)',
                        label: {show: false},
                        labelLine: {show: false}
                    },
                    emphasis: {
                        color: 'rgba(0,0,0,0)'
                    }
                };
                let option = {
                    tooltip: {
                        show: true,
                    },
                    legend: {
                        show: false
                    },
                    grid: {
                        left: 0,
                        top: 0,
                        right: 0,
                        bottom: 0
                    },
                    color: ['#BF3EFF','#2eaf68', '#258efe', '#f2bd2e','#FF0000'],
                    series: {
                        type: 'pie',
                        radius: "70%",
                        center: ['50%', '50%'],
                        labelLine: {
                            show: true,
                            length: 10,
                        },
                        label: {
                            show: true,
                            formatter: '{b}{c}',
                        },
                        data: [
                            {
                                value: this.chartPer.wbh ? this.chartPer.wbh : 0,
                                name: '未闭环'
                            },
                            {
                                value: this.chartPer.ybh ? this.chartPer.ybh : 0,
                                name: '已闭环',

                            },
                            {
                                value: this.chartPer.whf ? this.chartPer.whf : 0,
                                name: '未回复',

                            },
                            {
                                value: this.chartPer.yq ? this.chartPer.yq : 0,
                                name: '逾期',

                            },
                            {
                                value: this.chartPer.tz ? this.chartPer.tz : 0,
                                name: '跳闸',

                            }
                        ]
                    }
                }
                h_gaugePie.setOption(option);
            },
            //右下侧详细数据展示
            checkDetail(value) {
                this.detailShow = true;
                this.lianqunShow = false;
                this.ifchart = false;
                ss.xietongguanli.resourceXTDetail(value.id).then(rd => {
                    this.qdetail = rd;
                    this.qdetail.demand.euType = this.$getDictName("userCareType", rd.demand.euType);
                    this.qdetail.demand.areaCode = this.$getDictName("YLRegion", rd.demand.areaCode);
                });
            },
            //新增需求
            createdemand() {
                this.$router.push('/newCreateResource');
            },
            xuqiuEdit(value) {
                this.$router.push({
                    path: "/xuqiu/createResources",
                    query: {id: value.id, demandType: value.demandType}
                });
            },
            //点击详情跳转
            xuqiuDetail(value) {
                this.$router.push({path: "/newXieTongDetails", query: {id: value.id}});
            },
            //明细导出
            exportExcel() {
                updownfile.down("/api/swyl/v1/guanhuai/userResourceDemand/downloadExcel", this.q, "post");
            },
            closeIt1() {
                this.showOrhide1 = false;
                if (this.checked1) {
                    ss.salesList.toshow(this.toshow1, this.checked1).then(rd => {
                        console.log(rd)
                        this.showOrhide1 = false;
                    })
                } else {
                    ss.salesList.toshow(this.toshow1, this.checked1).then(rd => {
                        console.log(rd)
                        this.showOrhide1 = false;
                    })
                }
            },

            nextStep1(i) {
                if (this.status1 == 1) {
                    this.status1 = 2;
                } else if (this.status1 == 2) {
                    this.status1 = 3;
                } else if (this.status1 == 3) {
                    this.status1 = 4;
                } else if (this.status1 == 4) {
                    if (this.checked1) {
                        ss.salesList.toshow(this.toshow1, this.checked1).then(rd => {
                            console.log(rd)
                            this.showOrhide1 = false;
                        })
                    } else {
                        ss.salesList.toshow(this.toshow1, this.checked1).then(rd => {
                            console.log(rd)
                            this.showOrhide1 = false;
                        })
                    }
                }

            },
        },
        created() {
            this.showzhezhao();
            this.selectJobGroup();
            this.query();
            this.getAllLianqun();
            if(this._user.usertype==1){
                this.lianqunShow = false;
            }else{
                this.lianDataPage();
            }
            this.getDept();
        },
        mounted() {
            this.query1();
            this.options = {
                tooltip: {
                    show: true,
                },
                legend: {
                    show: false
                },
                grid: {
                    left: 0,
                    top: 0,
                    right: 0,
                    bottom: 0
                },
                /*color: ['#2eaf68', '#258efe', '#f2bd2e'],*/
                color: ['#BF3EFF','#2eaf68', '#258efe', '#f2bd2e','#FF0000'],
                series: {

                    type: 'pie',

                    selectedOffset: 10,
                    radius: "70%",
                    center: ['50%', '50%'],
                    labelLine: {
                        show: true,
                        length: 10,
                    },
                    label: {
                        show: true,
                        formatter: '{b}{c}',
                    },
                    data: [
                        {
                            value: this.chartPer.wbh ? this.chartPer.wbh : 0,
                            name: '未闭环'
                        },
                        {
                            value: this.chartPer.ybh ? this.chartPer.ybh : 0,
                            name: '已闭环',
                        },
                        {
                            value: this.chartPer.whf ? this.chartPer.whf : 0,
                            name: '未回复',
                        },
                        {
                            value: this.chartPer.yq ? this.chartPer.yq : 0,
                            name: '逾期',
                        },
                        {
                            value: this.chartPer.tz ? this.chartPer.tz : 0,
                            name: '跳闸',
                        }
                    ]
                }
            }
        },
    }
</script>

<style scoped>
    .cuname {
        font-size: 0.16rem;
        color: #323232;
    }

    .selectbbbb {
        display: flex;
        align-items: center;
        border-bottom: 2px solid #f9f9f9;
    }

    .selectbbbb:hover {
        background: #f5fcff;
    }

    .h-gaugePieLegend .h-gpLegendLi i {
        margin-top: -12px;
    }

    .totals {
        text-align: center;
        font-size: 0.22rem;
        color: #282828;
        margin-bottom: 20px;
    }


    .h-formLines {
        padding: 30px 48px;
    }

    .xuqiuBoxList {
        width: 100%;
        margin-top: 30px;
        display: flex;
        justify-content: space-between;
    }

    .xuqiuBoxList .xuqiulist {
        width: 200px;
        height: 62px;
        border-radius: 4px;
        background: #fff;
        border: 1px solid #959595;
        text-align: center;
        line-height: 62px;
        color: #989898;
        cursor: pointer;
        display: flex;
        justify-content: center;
        align-items: center;
        margin-left: 10px;
    }

    .xuqiuBoxList .xuqiulist:first-child {
        margin-left: 0
    }

    .xuqiuBoxList .xuqiulist.active {
        background: #238cfd;
        border: 1px solid #238cfd;
        color: #fff;
    }

    .xuqiutext {
        color: #bcbcbc;
        font-size: 14px;
        margin-bottom: 14px;
    }

    /* .piliang1 {
        font-size: 18px;
        color: #303030;
        margin-top: 10px;
        margin-left: 10px;
    }

    .piliang2 {
        font-size: 16px;
        color: #919191;
        margin-top: 10px;
        margin-left: 10px;
    } */

    /* .piliangBox {
        display: flex;
        margin-top: 20px;
        align-items: center;
        margin-left: 10px;
    }

    .piliangBox .imgs {
        font-size: 16px;
        color: #4b4b4b;
        margin-left: 20px;
    }

    .piliangBox .imgs:first-child {
        margin-left: 0
    } */
</style>
<style>
    .selectcheckbox .el-checkbox:hover {
        background: 0
    }

    .selectcheckbox .el-checkbox {
        margin-bottom: 5px
    }

    .selectcheckbox .el-checkbox__label {
        display: none
    }

    .h-dialogForm .h-elformWrap-3 .el-form-item__label:first-child {
        width: 23%;
    }

    .h-dialogForm .h-elformWrap-3 .el-form-item__content {
        width: 70%;
    }

    .el-form-item__content .secondX {
        position: absolute;
        top: 0;
        left: -89px;
        color: red;
        font-size: 0.2rem;
    }

    .h-dialog3.dialogFormVisible3 .el-dialog__body {
        padding: 0 0.5rem 0.3rem 0.5rem;
    }

    .h-dialog3.dialogFormVisible3 .el-dialog__body .el-upload--picture-card {
        width: 100%;
        height: 103px;
        border: 1px dashed #7c9ec0;
        background: 0;
        line-height: 103px;
        margin-top: 20px;
        color: #4b4b4b;
        font-size: 18px;
    }

    .fenyes .el-pagination .el-pagination__sizes {
        display: none;
    }

    /* .h-formBorder .timeselect .el-form-item__content {
        line-height: 0.2rem;
    } */

    .h-formBorder .timeselect .el-date-editor .el-range-separator {
        width: 8%;
        line-height: 28px;
    }

    .h-formBorder .timeselect .el-input__inner {
        padding-right: 0.1rem;
    }

    .timeselect .el-date-editor.el-input__inner {
        width: 3.5rem;
    }

    .ljjtablesdata.el-table tbody td:first-child{
        border-left: 0;
    }
    .ljjtablesdata.el-table tbody td:first-child{
        border-right: 1px solid #EBEEF5;
    }
    .ljjtablesdata.el-table tbody td:nth-child(2){
        border-right: 1px solid #EBEEF5;
    }
    .ljjtablesdata.el-table tbody td{
        border-right: 0;
    }
    .ljjtablesdata.el-table thead{
        color: #323232;
    }
    .ljjtablesdata.el-table thead tr{
        /*background-color: rgba(255,0,0,0.5);*/
        background-color: #f5fcff;
    }
    .ljjtablesdata.el-table thead th{
        background: #f5fcff;
    }
    .ljjtablesdata.el-table .warning-row {
        background: #f5fcff;
    }
    .ljjtablesdata.el-table .zfenleis{
        padding: 0.05rem;
        background: #fce0b7;
        color: #d99a4b;
        margin-right: 0.05rem;
    }
    .ljjtablesdata.el-table .zfenleis:nth-child(2){
        background: #d1e4ff;
        color: #006ccf;
    }
    .ljjtablexuqius .el-table tbody td .cell{
        padding: 0.1rem;
    }
</style>
<style scoped lang="scss">
    .bottomTip {
        position: absolute;
        left: 49.7%;
        bottom: 0.3rem;
        transform: translateX(-50%);
    }

    .newtext {
        font-size: 0.28rem;
        color: white;
        position: absolute;
        top: 0.2rem;
        left: 50%;
        transform: translateX(-50%);
        font-weight: bold;
        text-shadow: 1px 1px 4px #2785E7;
        z-index: 2;
    }

    .leaderBox {
        width: 100%;
        height: 100%;
        background-color: rgba(0, 0, 0, 0.4);
        position: fixed;
        z-index: 99999;
        overflow: hidden;
        top: 0;
        left: 0;

        .leaderbg {
            width: 100%;
            height: 100%;
        }

        .steps {
            position: absolute;
            z-index: 1;
        }

        .step4 {
            top: 0.8rem;
            left: 0rem;
            width: 6.6rem;
            height: 15rem;
        }

        .step5 {
            top: 2.2rem;
            right: 1.35rem;
            width: 4.7rem;
            height: 1rem;
        }

        .step6 {
            top: 2.28rem;
            left: 2.6rem;
            width: 9.2rem;
            height: 12rem;
        }

        .step7 {
            top: 3.45rem;
            right: 0.2rem;
            width: 6.9rem;
            height: 12rem;
        }

        .stepbtn {
            width: 1.9rem;
            height: 0.6rem;
            border: 0.03rem solid #FFFFFF;
            background-color: rgba(0, 0, 0, 0.1);
            border-radius: 5px;
            display: flex;
            justify-content: center;
            line-height: 0.5rem;
            position: absolute;
            z-index: 99;
            bottom: 0.75rem;
            left: 50%;
            transform: translateX(-50%);
            font-size: 0.27rem;
            letter-spacing: 2px;
            color: white;
            cursor: pointer;
        }

        .closeIt {
            width: 0.3rem;
            height: 0.3rem;
            position: absolute;
            top: 0.2rem;
            right: 0.2rem;
            cursor: pointer;
        }
    }
</style>
